import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 8v3a1 1 0 0 0 1 1h3","key":"svg-0"}],["path",{"d":"M18 8v8","key":"svg-1"}],["path",{"d":"M6 8v3a1 1 0 0 0 1 1h3","key":"svg-2"}],["path",{"d":"M10 8v8","key":"svg-3"}]]

const IconNumber44Small = createReactComponent('outline', 'number-44-small', 'Number44Small', __iconNode);

export default IconNumber44Small;